<template>
  <b-dropdown dropleft variant="link" :menu-class="'dropdown-custom__menu'"
              class="dropdown-custom dd-context-menu-photo"
              toggle-class="btn-event-options ml-2 text-decoration-none"
              no-caret>
    <template #button-content>
      <Icon name="dotsVertical" width="33" />
    </template>


    <!-- REMOVE CHECKIN -->
    <b-dropdown-item href="#" @click.prevent="$emit('remove-photo')">
     <Icon name="trash" :width="18" class="mr-1" vertical-align="sub" /> {{ $t('pages.checkins_detail.btn_remove_photo') }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>


export default {
  name: "CheckinMenuMedia",

  props: {
    photoId: {
      required: true,
    },
  },
  created() {

  }
}
</script>
